var React = require('react');

function IconvcspeakdoctorInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.12,3.93h0a30,30,0,0,1,30,30v30a0,0,0,0,1,0,0h-30a30,30,0,0,1-30-30v0a30,30,0,0,1,30-30Z","fill":"#fff","stroke":"#003c61","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"23.12","y1":"33.93","x2":"47.12","y2":"33.93","fill":"none","stroke":"#003c61","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6.3","key":1}),React.createElement("line",{"x1":"35.12","y1":"21.93","x2":"35.12","y2":"45.93","fill":"none","stroke":"#003c61","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6.3","key":2})]);
}

IconvcspeakdoctorInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 70 70"};

module.exports = IconvcspeakdoctorInline;

IconvcspeakdoctorInline.default = IconvcspeakdoctorInline;
